import { AuctionList } from './components/AuctionList.tsx';
import { apiRoutes } from '../../../../constants/apiRoutes.ts';
import { AuctionType, SaleStatus } from '../../../auctions/types.ts';
import { ActiveAuctionCard } from './components/SaleCards/ActiveAuctionCard.tsx';

export const NonTimedAuctions = () => {
  return (
    <AuctionList
      title={'Sales and Events In-Progress'}
      route={apiRoutes.auctions.list}
      queryParameters={{ excludeTypes: [AuctionType.Timed], status: SaleStatus.Selling }}
      renderItem={ActiveAuctionCard}
      emptyListMessage={'No Live sales or events currently in progress'}
    />
  );
};
